import React from 'react'

const Warning = ({ confirmAction, onClose, text }) => {
  return (
    <div className='mint-warning'>
      {/* Display the warning message */}
      <h1 className='mint-warning-msg'>{text}</h1>
      
      {/* Action buttons for user response */}
      <div className='mint-warning-btns'>
        {/* 'Yes' button triggers confirmAction when clicked */}
        {/* <button className='mint-warning-btn' onClick={confirmAction}>Yes</button> */}
        
        {/* 'No' button triggers onClose to close the warning */}
        <button className='mint-warning-btn' onClick={confirmAction}>OK</button>
      </div>
    </div>
  )
}

export default Warning
